// extracted by mini-css-extract-plugin
export default {"container":"_3RMMI","section":"_1nUeI","title":"_NbL8p","body":"_1exNC","cta":"_1CBXZ"};